(() => {
  if (customElements.get('sdc-season-home')) return;
  customElements.define('sdc-season-home', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.index = 0;
      this.slides = [...this.querySelectorAll('[data-slide]')];
      this.slider = this.querySelector('.sdc-home-slider');
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.show = index => {
        this.index = (index + this.slides.length) % this.slides.length;
        this.slides.forEach((slide, i) => { slide.hidden = i !== this.index; });
      };
      this.querySelectorAll('[data-swipe-zone]').forEach(zone => {
        zone.addEventListener('dragstart', event => event.preventDefault(), options);
        zone.addEventListener('pointerdown', event => {
          if (event.button !== 0) return;
          this.start = { x: event.clientX, y: event.clientY, id: event.pointerId };
          clearInterval(this.timer);
          zone.setPointerCapture(event.pointerId);
        }, options);
        zone.addEventListener('pointerup', event => {
          if (!this.start || this.start.id !== event.pointerId) return;
          const dx = event.clientX - this.start.x, dy = event.clientY - this.start.y;
          this.start = null;
          if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.3) this.show(this.index + (dx < 0 ? 1 : -1));
          this.restart();
        }, options);
        zone.addEventListener('pointercancel', () => { this.start = null; this.restart(); }, options);
        zone.addEventListener('keydown', event => {
          if (!['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
          event.preventDefault(); this.show(this.index + (event.key === 'ArrowRight' ? 1 : -1));
          this.querySelector('[data-slide]:not([hidden]) [data-swipe-zone]').focus();
          this.restart();
        }, options);
      });
      this.slider.addEventListener('focusin', () => clearInterval(this.timer), options);
      this.slider.addEventListener('focusout', () => this.restart(), options);
      document.addEventListener('visibilitychange', () => this.restart(), options);
      this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.restart();
    }
    restart() {
      clearInterval(this.timer);
      if (!this.reduced.matches && !document.hidden && !this.slider.contains(document.activeElement)) this.timer = setInterval(() => this.show(this.index + 1), 9000);
    }
    disconnectedCallback() { clearInterval(this.timer); this.abort?.abort(); }
  });
})();
